export const TOGGLE_DEGREE_FILTER_MENU = 'ibw/SearchDegree/TOGGLE_DEGREE_FILTER_MENU';
